import { useNuxtApp } from '#imports'

/**
 * Retrieve the instance of front-logger.
 *
 * @example
 * const logger = useLogger()
 *
 * logger.info('My info log message', payload)
 * logger.debug('My debug log message', payload)
 * logger.error('My error log message', payload)
 */
export function useLogger() {
  return useNuxtApp().$logger
}
